import * as React from "react"
import {
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container
} from "reactstrap"
import { FormattedMessage, intlShape } from "react-intl"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  IPriceCompareDetail,
  IRouteTrip
} from "../../redux/sagaBooking/IBooking"
import * as Immutable from "seamless-immutable"
import * as _ from "lodash"
import { Link, Redirect } from "react-router-dom"
import { generateRandom } from "../../helpers/utility"

class CartModal extends React.Component<
  {
    visible: boolean
    cars: IPriceCompareDetail[]
    routes: IRouteTrip[]
    language: string
    search: string
    onToggle: () => void
    onClose: () => void
    onRemoveCar: (cars: IPriceCompareDetail[], routes: IRouteTrip[]) => void
  },
  {
    isRedirect: boolean
  }
> {
  constructor(props) {
    super(props)
    this.state = {
      isRedirect: false
    }
  }

  public onRemoveCar(carTypeClassId: number) {
    let { cars } = this.props
    const { onRemoveCar, routes } = this.props
    cars =
      cars &&
      cars.filter(
        c => c.carTypeClass && c.carTypeClass.carTypeClassId !== carTypeClassId
      )
    onRemoveCar(cars, routes)
  }

  public onChangeQuantity(carTypeClassId: number, type: "plus" | "minus") {
    let { cars } = this.props
    const { onRemoveCar, routes } = this.props
    cars = [...cars]

    const datas: IPriceCompareDetail[] = Immutable.asMutable(cars, {
      deep: true
    })
    // tslint:disable-next-line:only-arrow-functions
    const index = _.findIndex(datas, function(o: IPriceCompareDetail) {
      return o.carTypeClass.carTypeClassId === carTypeClassId
    })
    datas[index].carTypeClass.quantity =
      type === "plus"
        ? datas[index].carTypeClass.quantity + 1
        : datas[index].carTypeClass.quantity === 1
        ? 1
        : datas[index].carTypeClass.quantity - 1

    onRemoveCar(datas, routes)
  }

  public onRemoveRoute(key: string) {
    let { routes } = this.props
    const { cars, onRemoveCar } = this.props
    routes = routes && routes.filter(r => r.key !== key)
    onRemoveCar(cars, routes)
  }

  public onNext() {
    this.props.onClose()
    this.setState({ isRedirect: true })
    return (
      <Redirect
        to={`/${this.props.language}/bookingInfo?${this.props.search}`}
      />
    )
  }

  public render() {
    const {
      onToggle,
      onClose,
      visible,
      cars,
      routes,
      language,
      search
    } = this.props

    const { isRedirect } = this.state
    return (
      <Modal
        isOpen={visible}
        toggle={() => onToggle()}
        // centered={true}
        size={"lg"}
        // scrollable={"true"}
      >
        <ModalHeader
          className="hiso-bus-rental-bg-color-bule text-white"
          toggle={() => onToggle()}
        >
          <b>
            <FormattedMessage id="vehicles" />
          </b>
        </ModalHeader>
        <ModalBody>
          <Row className="pb-3">
            <Col>
              <h5>
                <b>
                  <FontAwesomeIcon icon={["fas", "bus-alt"]} />{" "}
                  <FormattedMessage id="vehicles" />
                </b>
              </h5>
            </Col>
          </Row>
          <Row>
            {cars && cars.length > 0 ? (
              <Col>
                {cars.map(c => {
                  return (
                    <div
                      key={generateRandom()}
                      className="shadow p-2 mb-2 bg-white rounded"
                    >
                      <Container>
                        <Row className="align-items-center pr-1">
                          <Col xs="auto" className="pl-1 pr-0">
                            <div className="hiso-bus-rental-bg-color-orange text-white p-1">
                              {c.carTypeClass &&
                                c.carTypeClass.carClassView &&
                                c.carTypeClass.carClassView.engName}
                            </div>
                          </Col>
                          <Col xs="" className="pl-1 pr-0">
                            <div className="p-1">
                              <b>
                                {language === "th"
                                  ? c.carTypeClass &&
                                    c.carTypeClass.carTypeView &&
                                    c.carTypeClass.carTypeView.name
                                  : c.carTypeClass &&
                                    c.carTypeClass.carTypeView &&
                                    c.carTypeClass.carTypeView.enName}
                              </b>
                            </div>
                          </Col>
                          <Col xs="auto" className="pl-1 pr-0">
                            <div className=" p-1 ">
                              <b>
                                <span
                                  className="pr-1 hiso-bus-mouse-pointer"
                                  onClick={() =>
                                    this.onChangeQuantity(
                                      c.carTypeClass &&
                                        c.carTypeClass.carTypeClassId,
                                      "minus"
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "minus-circle"]}
                                  />
                                </span>
                                {(c.carTypeClass && c.carTypeClass.quantity) ||
                                  1}
                                <span
                                  className="pl-1 hiso-bus-mouse-pointer"
                                  onClick={() =>
                                    this.onChangeQuantity(
                                      c.carTypeClass &&
                                        c.carTypeClass.carTypeClassId,
                                      "plus"
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "plus-circle"]}
                                  />
                                </span>
                              </b>
                            </div>
                          </Col>
                          <Col xs="auto" className="pl-1 pr-0">
                            <div className=" p-1 ">
                              <b>
                                {(c.discount
                                  ? c.discount.discountedPrice *
                                    ((c.carTypeClass &&
                                      c.carTypeClass.quantity) ||
                                      1)
                                  : c.price *
                                    ((c.carTypeClass &&
                                      c.carTypeClass.quantity) ||
                                      1)
                                ).toLocaleString()}{" "}
                                <FormattedMessage id="Baht" />
                                <span
                                  className="pl-1 text-danger hiso-bus-mouse-pointer"
                                  onClick={() =>
                                    this.onRemoveCar(
                                      c.carTypeClass &&
                                        c.carTypeClass.carTypeClassId
                                    )
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={["fas", "minus-circle"]}
                                  />
                                </span>
                              </b>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  )
                })}
              </Col>
            ) : (
              <Col>
                <div className="shadow p-5 mb-2 bg-white rounded text-center">
                  <span
                    className="text-center p-3"
                    style={{
                      borderRadius: "50% 50%",
                      backgroundColor: "lightgray"
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "bus-alt"]} />
                  </span>
                </div>
              </Col>
            )}
          </Row>
          <Row className="pb-3 pt-3">
            <Col>
              <h5>
                <b>
                  <FontAwesomeIcon icon={["fas", "map-signs"]} />
                  {` `}
                  <FormattedMessage id="booking.payment.summaryRouteOrder" />
                </b>
              </h5>
            </Col>
          </Row>
          <Row>
            {routes && routes.length > 0 ? (
              <Col>
                {routes.map(r => {
                  return (
                    <div
                      key={generateRandom()}
                      className="shadow p-2 mb-2 bg-white rounded"
                    >
                      <Container>
                        <Row className="align-items-center pr-1">
                          <Col xs="auto" className="pl-1 pr-0">
                            <div className="text-blue p-1">
                              <FontAwesomeIcon
                                icon={["fas", "map-marker-alt"]}
                              />
                            </div>
                          </Col>
                          <Col xs="" className="pl-1 pr-0">
                            <div className="p-1">
                              <b>{r.name} </b>
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  )
                })}
              </Col>
            ) : (
              <Col>
                <div className="shadow p-5 mb-2 bg-white rounded text-center">
                  <span
                    className="text-center p-3"
                    style={{
                      borderRadius: "50% 50%",
                      backgroundColor: "lightgray"
                    }}
                  >
                    <FontAwesomeIcon icon={["fas", "map-signs"]} />
                  </span>
                </div>
              </Col>
            )}
          </Row>
          <hr />
          <Row className="align-items-center justify-content-end">
            <Col>
              <h4 className="text-right">
                <b>
                  <FormattedMessage id="Total" />
                  {` `}
                  <span style={{ fontSize: 15 }}>
                    (<FormattedMessage id="excludesVat" />)
                  </span>{" "}
                  <span>
                    {(
                      cars &&
                      cars.reduce((sum, car) => {
                        return (
                          sum +
                          (car.discount
                            ? car.discount.discountedPrice
                            : car.price) *
                            ((car.carTypeClass && car.carTypeClass.quantity) ||
                              1)
                        )
                      }, 0)
                    ).toLocaleString() || 0}
                  </span>{" "}
                  <FormattedMessage id="Baht" />
                </b>
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => onToggle()}>
            <FormattedMessage id="Close" />
          </Button>
          {cars && cars.length > 0 ? (
            <Link to={`/${language}/bookingInfo?${search}`}>
              <Button
                color="primary"
                className="btn-blue"
                disabled={false}
                style={{ minWidth: 120 }}
                // onClick={() => this.onNext()}
              >
                <FormattedMessage id="Next" />
              </Button>{" "}
            </Link>
          ) : (
            <Button
              color="primary"
              className="btn-blue"
              disabled={true}
              style={{ minWidth: 120 }}
              // onClick={() => this.onNext()}
            >
              <FormattedMessage id="Next" />
            </Button>
          )}
        </ModalFooter>
      </Modal>
    )
  }
}

export default CartModal



// WEBPACK FOOTER //
// ./src/components/cart/cartModal.tsx